import axios from 'axios';

import {HttpClient, RequestOption} from 'data/protocols/http';
import {axiosInstance} from './axios-instance';

export class AxiosHttpAdapter implements HttpClient {
	// eslint-disable-next-line class-methods-use-this
	public async request<Response>(option: RequestOption): Promise<Response> {
		try {
			const response = await axiosInstance.request({
				method: option.method,
				url: option.url,
				headers: option.headers,
				data: option.body,
				params: option.params,
				responseType: option.responseType,
				onUploadProgress: option.onUploadProgress,
				signal: option.signal,
			});
			return <Response>(<unknown>{
				status: response.status,
				data: response.data,
				headers: response.headers as Record<string, string>,
			});
		} catch (error) {
			if (axios.isAxiosError(error) && error.response) {
				return <Response>(<unknown>{
					status: error.response.status,
					data: error.response.data,
					headers: error.response.headers as Record<string, string>,
				});
			}

			throw error;
		}
	}
}
